import { useApolloClient } from "@apollo/client";

/**
 * Refetches the two waste stream grid queries after an action that changes a
 * stream's registration state, scoped to one facility — mirrors
 * `WasteStreamMergeDialog`'s `client.refetchQueries` pattern so a stale
 * instance of `WasteStreams` for a *different*, previously-visited facility
 * isn't refetched. `TenantWasteStreams` has no `facilityId` variable, so it
 * always refetches. An absent `facilityId` leaves every per-facility instance
 * alone rather than refetching them all.
 */
export function refetchWasteStreamGridQueries(
  client: ReturnType<typeof useApolloClient>,
  facilityId: string | null | undefined
) {
  return client.refetchQueries({
    include: ["WasteStreams", "TenantWasteStreams"],
    onQueryUpdated(observableQuery) {
      const queryFacilityId = observableQuery.variables?.facilityId;
      if (queryFacilityId && queryFacilityId !== facilityId) {
        return false;
      }
      return observableQuery.refetch();
    },
  });
}
